import {
    AppConfig,
    getConfig,
} from '@superbet-group/web.lib.config';
import { SiteLanguageConfig } from '@modules/app/siteLanguage/siteLanguageConfig';
import { Country } from '@superbet-group/web.types';

export function createGetCmsLocalePath(config: AppConfig, isMultiLingualTarget: boolean) {
    return function getCmsLocalePath(): string {
        // TODO(Tomica): Remove when RoNapoleon is added to directus
        const country = config.countrySpecific.country === Country.RoNapoleon ? Country.Ro : config.countrySpecific.country;

        return isMultiLingualTarget
            ? config.appLocale.locale
            : country;
    };
}
/**
 * @return full locale (e.g. en-be) for the multilingual target, otherwise just the language (e.g. en)
 */
export const getCmsLocalePath = createGetCmsLocalePath(
    getConfig(),
    SiteLanguageConfig.isMultiLingualSite,
);

export function createGetCmsUrl(base: string) {
    return function getCmsUrl({
        path,
        queryParams,
    }: {
        path: string;
        queryParams?: {
            [key: string]: string;
        };
    }) {
        const cleanBase = base.endsWith('/')
            ? base.slice(0, -1)
            : base;

        const cleanPath = path.startsWith('/')
            ? path
            : `/${path}`;

        try {
            const url = new URL(`${cleanBase}${cleanPath}`);

            if (queryParams) {
                Object.entries(queryParams).forEach(([key, value]) => {
                    url.searchParams.append(key, value);
                });
            }

            return url.href;
        } catch (e) {
            return '';
        }
    };
}

export const getCmsUrl = createGetCmsUrl(`${getConfig().cms!.baseUrl}/cached-superbet`);
